import { AbstractControl } from '@angular/forms';

export abstract class AbstractEditionModalForm<T> {
  form: AbstractControl;

  abstract updateForm(model?: T);

  abstract getFormData(): any;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/modals/edition-modal/abstract-edition-modal-form.ts